import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Employee from '../views/Employee.vue'
import Contract from '../views/Contract.vue'
import Project from '../views/Project.vue'
import ProjectDetail from '../views/ProjectDetail.vue'
import Driver from '../views/Driver.vue'
import Department from '../views/Department.vue'
import Reimbursement from '../views/Reimbursement.vue'
import Product from '../views/Product.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: { title: '数据看板', requiresAuth: true }
      },
      {
        path: 'employee',
        name: 'employee',
        component: Employee,
        meta: { title: '员工管理', requiresAuth: true }
      },
      {
        path: 'contract',
        name: 'contract',
        component: Contract,
        meta: { title: '合同管理', requiresAuth: true }
      },
      {
        path: 'project',
        name: 'project',
        component: Project,
        meta: { title: '项目管理', requiresAuth: true }
      },
      {
        path: 'project/detail/:id',
        name: 'project-detail',
        component: ProjectDetail,
        meta: { title: '项目详情', requiresAuth: true, fullScreen: true }
      },
      {
        path: 'driver',
        name: 'driver',
        component: Driver,
        meta: { title: '司机管理', requiresAuth: true }
      },
      {
        path: 'department',
        name: 'department',
        component: Department,
        meta: { title: '部门管理', requiresAuth: true }
      },
      {
        path: 'reimbursement',
        name: 'reimbursement',
        component: Reimbursement,
        meta: { title: '报销管理', requiresAuth: true }
      },
      {
        path: 'product',
        name: 'product',
        component: Product,
        meta: { title: '产品管理', requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login')
  } else if (to.matched.some(record => record.meta.guest) && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
